var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "your-plan-container w-100" }, [
    _c("div", { staticClass: "d-flex flex-column gap-20 w-100" }, [
      _c("p", { staticClass: "font-weight-bold font-size-175 mb-0" }, [
        _vm._v(
          "\n            " + _vm._s(_vm._f("trans")("Your Plan")) + "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "border-box flex-column" }, [
        _c("div", { staticClass: "d-flex flex-column gap-10 w-100" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            this.selectedProduct === "payg"
              ? _c("strong", { staticClass: "font-size-125" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Pay As You Go"))),
                ])
              : _c("strong", { staticClass: "font-size-125" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Subscription"))),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column align-items-end" }, [
              _c("div", { staticClass: "d-flex gap-10" }, [
                _c("div", { staticClass: "icon-container" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M8.00004 3.33333C9.72804 3.33333 11.324 3.64333 12.5134 4.172C13.1067 4.436 13.6294 4.76733 14.0114 5.16933C14.3974 5.57333 14.6667 6.08133 14.6667 6.66667V9.33333C14.6667 9.91867 14.3974 10.426 14.0114 10.8307C13.6294 11.2327 13.1074 11.564 12.5134 11.828C11.324 12.3567 9.72804 12.6667 8.00004 12.6667C6.27204 12.6667 4.67604 12.3567 3.48671 11.828C2.89337 11.564 2.37071 11.2327 1.98871 10.8307C1.60271 10.4267 1.33337 9.91867 1.33337 9.33333V6.66667C1.33337 6.08133 1.60271 5.574 1.98871 5.16933C2.37071 4.76733 2.89271 4.436 3.48671 4.172C4.67604 3.64333 6.27204 3.33333 8.00004 3.33333ZM13.3334 8.72C13.0834 8.884 12.8067 9.03067 12.5134 9.16133C11.324 9.69 9.72804 10 8.00004 10C6.27204 10 4.67604 9.69 3.48671 9.16133C3.20197 9.03647 2.92775 8.88888 2.66671 8.72V9.33333C2.66671 9.48467 2.73337 9.67867 2.95471 9.912C3.17937 10.148 3.53604 10.3913 4.02804 10.61C5.01071 11.0467 6.41471 11.3333 8.00004 11.3333C9.58604 11.3333 10.9894 11.0467 11.972 10.61C12.464 10.3913 12.8207 10.148 13.0454 9.912C13.2674 9.67867 13.3334 9.48467 13.3334 9.33333V8.72ZM8.00004 4.66667C6.41404 4.66667 5.01071 4.95333 4.02804 5.39C3.53604 5.60867 3.17937 5.852 2.95471 6.088C2.73271 6.32133 2.66671 6.51533 2.66671 6.66667C2.66671 6.818 2.73337 7.012 2.95471 7.24533C3.17937 7.48133 3.53604 7.72467 4.02804 7.94333C5.01071 8.38 6.41471 8.66667 8.00004 8.66667C9.58604 8.66667 10.9894 8.38 11.972 7.94333C12.464 7.72467 12.8207 7.48133 13.0454 7.24533C13.2674 7.012 13.3334 6.818 13.3334 6.66667C13.3334 6.51533 13.2667 6.32133 13.0454 6.088C12.8207 5.852 12.464 5.60867 11.972 5.39C10.9894 4.954 9.58537 4.66667 8.00004 4.66667Z",
                          fill: "#2E2E2E",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("strong", { staticClass: "font-size-125" }, [
                  _vm._v(_vm._s(_vm.productCredits)),
                ]),
              ]),
              _vm._v(" "),
              _vm.selectedProduct === "subscription"
                ? _c("strong", [_vm._v(_vm._s(_vm._f("trans")("/month")))])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("span", { staticClass: "font-size-125" }, [
              _vm._v(_vm._s(_vm._f("trans")("Billed"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-size-125" }, [
              _vm._v(_vm._s(_vm.billingText())),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("strong", { staticClass: "font-size-125" }, [
              _vm._v(_vm._s(_vm._f("trans")("Due today"))),
            ]),
            _vm._v(" "),
            _c("strong", { staticClass: "font-size-125" }, [
              _vm._v(_vm._s(_vm.productPriceString)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column gap-10" }, [
          _c("div", { staticClass: "d-flex gap-10" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "22",
                  viewBox: "0 0 24 22",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53025C1 4.51605 1.36009 3.64886 2.08026 2.92869C2.80043 2.20852 3.66761 1.84843 4.68182 1.84843H15.3182C15.8551 1.84843 16.3537 1.95497 16.8139 2.16804C16.9418 2.2277 17.0185 2.32571 17.044 2.46207C17.0696 2.60696 17.0312 2.73054 16.929 2.83281L16.3026 3.45923C16.2173 3.54446 16.1193 3.58707 16.0085 3.58707C15.983 3.58707 15.9446 3.57855 15.8935 3.5615C15.6974 3.51037 15.5057 3.4848 15.3182 3.4848H4.68182C4.11932 3.4848 3.63778 3.68508 3.23722 4.08565C2.83665 4.48622 2.63636 4.96775 2.63636 5.53025V16.1666C2.63636 16.7291 2.83665 17.2107 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2107 17.3636 16.7291 17.3636 16.1666V12.9195C17.3636 12.8087 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84985L11.5469 16.2561C11.3423 16.4607 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4607 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0303C4.28551 9.749 4.38778 9.5061 4.59233 9.30156L5.99858 7.89531C6.20312 7.69076 6.44602 7.58849 6.72727 7.58849C7.00852 7.58849 7.25142 7.69076 7.45597 7.89531L10.8182 11.2575L19.0895 2.98622C19.294 2.78167 19.5369 2.6794 19.8182 2.6794C20.0994 2.6794 20.3423 2.78167 20.5469 2.98622L21.9531 4.39247C22.1577 4.59701 22.2599 4.83991 22.2599 5.12116C22.2599 5.40241 22.1577 5.64531 21.9531 5.84985Z",
                    fill: "#0B7335",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            this.selectedProduct === "payg"
              ? _c("span", { staticClass: "font-size-125" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Credits valid for one year"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            this.selectedProduct === "subscription"
              ? _c("span", { staticClass: "font-size-125" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Cancel anytime"))),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex gap-10" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "22",
                  viewBox: "0 0 24 22",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53025C1 4.51605 1.36009 3.64886 2.08026 2.92869C2.80043 2.20852 3.66761 1.84843 4.68182 1.84843H15.3182C15.8551 1.84843 16.3537 1.95497 16.8139 2.16804C16.9418 2.2277 17.0185 2.32571 17.044 2.46207C17.0696 2.60696 17.0312 2.73054 16.929 2.83281L16.3026 3.45923C16.2173 3.54446 16.1193 3.58707 16.0085 3.58707C15.983 3.58707 15.9446 3.57855 15.8935 3.5615C15.6974 3.51037 15.5057 3.4848 15.3182 3.4848H4.68182C4.11932 3.4848 3.63778 3.68508 3.23722 4.08565C2.83665 4.48622 2.63636 4.96775 2.63636 5.53025V16.1666C2.63636 16.7291 2.83665 17.2107 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2107 17.3636 16.7291 17.3636 16.1666V12.9195C17.3636 12.8087 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84985L11.5469 16.2561C11.3423 16.4607 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4607 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0303C4.28551 9.749 4.38778 9.5061 4.59233 9.30156L5.99858 7.89531C6.20312 7.69076 6.44602 7.58849 6.72727 7.58849C7.00852 7.58849 7.25142 7.69076 7.45597 7.89531L10.8182 11.2575L19.0895 2.98622C19.294 2.78167 19.5369 2.6794 19.8182 2.6794C20.0994 2.6794 20.3423 2.78167 20.5469 2.98622L21.9531 4.39247C22.1577 4.59701 22.2599 4.83991 22.2599 5.12116C22.2599 5.40241 22.1577 5.64531 21.9531 5.84985Z",
                    fill: "#0B7335",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "font-size-125" }, [
              _vm._v(_vm._s(_vm._f("trans")("Full money back guarantee"))),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.showSaveSection()
      ? _c("div", { staticClass: "d-flex flex-column gap-20 w-100" }, [
          _c("p", { staticClass: "font-weight-bold font-size-175 mb-0" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("trans")("Save Now up to 20%")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border-box" }, [
            _c("div", { staticClass: "custom-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.billingYearly,
                    expression: "billingYearly",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.billingYearly)
                    ? _vm._i(_vm.billingYearly, null) > -1
                    : _vm.billingYearly,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.billingYearly,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.billingYearly = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.billingYearly = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.billingYearly = $$c
                    }
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column gap-10" }, [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("strong", { staticClass: "font-size-125" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Pay Yearly and Save!"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "save-box" }, [
                  _c("strong", { staticClass: "font-size-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")("Save %amount%", {
                          "%amount%": _vm.amountSavedForAnnual,
                        })
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "font-size-125" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")(
                      "Choose the annual payment option to save more money and pay less overall."
                    )
                  )
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }